import { useVisibility } from "@/contexts/VisibilityContext";

export default function VisibilityGuard({ visKey, children }) {
  const { get } = useVisibility();
  const v = get(visKey);

  if (v.state === "hidden") return <PageNotFound />;
  if (v.state === "coming_soon") return <PageComingSoon label={v.label} teaser={v.teaser} />;
  return children;
}

function PageNotFound() {
  return (
    <div className="py-32 text-center">
      <div className="font-display text-7xl lg:text-9xl font-bold text-white/5 select-none">404</div>
      <div className="mt-4 text-white/60 text-lg">This page isn't available.</div>
    </div>
  );
}

function PageComingSoon({ label, teaser }) {
  return (
    <div className="py-32 text-center">
      <div className="text-[11px] uppercase tracking-widest text-white/40 font-mono">Coming soon</div>
      <h1 className="font-display text-4xl lg:text-5xl mt-4 tracking-tighter">
        {label || "Something is being built."}
      </h1>
      {teaser && <p className="mt-4 text-white/60 max-w-md mx-auto leading-relaxed">{teaser}</p>}
    </div>
  );
}
